// Components
import { StepIntegrationYoutubeComponent } from './step-integration-youtube.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_INTEGRATION_YOUTUBE = {
  stepIdentifier: 'mediaUploadFlowStepIntegrationYoutube',
  identifier: 'youtube',
  component: StepIntegrationYoutubeComponent,
  name: 'YouTube',
  title: 'YouTube Configuration',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
  subStep: true,
} as MediaUploadFlowStep;
